export default __webpack_public_path__ + "static/technology-bg-e5d678729d5c1fa524819b702ac1597e.jpeg";